import { ProductQtyErrorCode } from '../../../generated/graphql';

export type ValidateQuantityResType = {
  isValid: boolean;
  errorCode: ProductQtyErrorCode;
};

export class Validation {
  public static validateQuantity(
    minQty: number,
    ssm: number,
    qty: number,
    qtyInStock?: number,
    isBackOrdered?: boolean,
    denyBackOrder?: boolean
  ): ValidateQuantityResType {
    let errorCode = ProductQtyErrorCode.None;

    let isValid = !isNaN(qty) && qty >= minQty && qty % ssm === 0;

    // following logic in ms ValoriseTransaction.cs
    if (isNaN(qty) || (qty % ssm !== 0 && qty >= minQty) || qty <= 0) {
      errorCode = ProductQtyErrorCode.InvalidQuantity;
    }
    //use with caution for DTP if you are updating the qty in the basket where qtyInStock changes based on selected qty
    else if (qtyInStock && qty > qtyInStock && !isBackOrdered && denyBackOrder) {
      errorCode = ProductQtyErrorCode.QuantityUnavailable;
    } else if (qty < minQty) {
      errorCode = ProductQtyErrorCode.QuantityBelowMin;
    }

    if (errorCode !== ProductQtyErrorCode.None) {
      isValid = false;
    }

    return { isValid, errorCode };
  }

  public static isPhoneNumberValid(val: string): boolean {
    let match = val.match(/(^\+)?\d+(\d|\s)+\d$/);
    let isValid = match !== null && val === match[0];

    //check phone length
    const digitOnlyValLength = (val.match(/\d/g) || []).length;
    isValid = isValid ? digitOnlyValLength >= 8 && digitOnlyValLength <= 15 : false;

    return isValid;
  }
}
